export class Mail {
  nome!: string;
  email!: string;
  assunto!: string;
  mensagem!: string;
  recaptcha!: string;
}
